import React, { useState, useEffect } from "react";
import {
  Checkbox,
  Tabs,
  Tab,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  FormControlLabel
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getVal, setBool } from "../../helpers/process_morningstar.js";



function Comparables() {

  return (
    <Box sx={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "stretch",
        width: '50%',
        height: 450
      }}
    >
        <Typography sx={{
            paddingTop: 10,
            fontWeight: 'bold',
            color: "#4e95d9"
        }}>
            Comparables
        </Typography>
        <Typography sx={{
            paddingTop: 20
        }} >
            Coming soon
        </Typography>
    </Box>
  );
}

export default Comparables;
